import { ReactElement, useState } from 'react';
import cn from 'classnames';

import cms from '../../data/cms.json';
import styles from './DecreasingProgressionDownload.module.scss';

import { Icon } from '../Icon/Icon';
import { Loader } from '../Loader/Loader';
import { ModelProps } from '../../types/model';
import { downloadCoverageDecreasingProgression } from '../../utils/downloadCoverageDecreasingProgression';
import { getDataTest } from '../../utils/dataTests';

interface DecreasingProgressionDownloadProps {
    model: ModelProps;
    className?: string;
}

// ### Button which downloads pdf document with decreasing sum insured progression preview

export const DecreasingProgressionDownload = ({
    model,
    className,
    ...props
}: DecreasingProgressionDownloadProps): ReactElement => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const handleClick = async () => {
        if (loading) {
            return;
        }

        setLoading(true);
        setError(false);

        try {
            await downloadCoverageDecreasingProgression(model);
        } catch (err) {
            console.error(err);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={cn(styles.wrapper, className)} {...props}>
            <button
                type="button"
                className={cn(styles.button, loading && styles.isLoading)}
                onClick={handleClick}
                disabled={loading}
                data-test={getDataTest(props, 'Button')}
            >
                {loading ? (
                    <Loader size="xsmall" className={styles.loader} />
                ) : (
                    <Icon name="download" className={styles.icon} />
                )}
                {cms.common.decreasingProgressionButton}
            </button>

            {error && (
                <span className={styles.error} data-test={getDataTest(props, 'Error')}>
                    {cms.common.decreasingProgressionError}
                </span>
            )}
        </div>
    );
};
